var _path, _g, _polygon, _polygon2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m103.17,114.9c-3.29-4.66-7.66-8.4-12.99-11.14-5.17-2.65-10.88-4.83-16.97-6.49-5.96-1.62-12.09-3.17-18.22-4.6-5.99-1.4-11.54-3.14-16.5-5.18-4.77-1.95-8.63-4.6-11.48-7.88-2.73-3.13-4.11-7.44-4.11-12.79,0-4.66,1.27-8.94,3.78-12.69,2.51-3.77,6.5-6.85,11.85-9.16,5.46-2.36,12.5-3.55,20.91-3.55,5.9,0,12.13.93,18.5,2.76,6.34,1.82,12.36,4.66,17.9,8.43l1.87,1.28,5.33-11.5-1.28-.93c-5.36-3.88-11.89-7-19.41-9.26-7.5-2.26-15.21-3.4-22.9-3.4-11.43,0-20.96,1.77-28.35,5.26-7.47,3.53-13.06,8.24-16.62,14-3.56,5.74-5.36,12.13-5.36,18.97,0,7.52,1.66,13.76,4.92,18.55,3.23,4.74,7.57,8.53,12.91,11.27,5.18,2.66,10.96,4.84,17.17,6.49,6.1,1.62,12.22,3.17,18.2,4.6,5.87,1.41,11.36,3.15,16.31,5.18,4.78,1.96,8.68,4.62,11.59,7.89,2.79,3.14,4.2,7.44,4.2,12.78,0,4.52-1.3,8.69-3.85,12.37-2.58,3.71-6.63,6.73-12.04,8.98-5.53,2.3-12.8,3.46-21.61,3.46s-17.28-1.63-25.14-4.83c-7.85-3.2-14.1-7.16-18.58-11.76l-1.73-1.78-6.52,10.77.96,1.06c5.13,5.67,12.44,10.34,21.73,13.88,9.22,3.52,19.14,5.3,29.48,5.3,11.55,0,21.17-1.73,28.62-5.15,7.53-3.46,13.23-8.17,16.92-13.99,3.7-5.82,5.57-12.17,5.57-18.89,0-7.4-1.69-13.55-5.04-18.29Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 134.11,
    y: 93.06,
    width: 90.88,
    height: 12.92
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 134.11,
    y: 30.7,
    width: 90.88,
    height: 12.92
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 134.11,
    y: 154.46,
    width: 90.88,
    height: 12.92
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "249.34 28.78 249.34 41.61 298.54 41.61 298.54 169.28 312.34 169.28 312.34 41.61 361.54 41.61 361.54 28.78 249.34 28.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "442.43 28.78 430.01 28.78 365.38 169.28 380.36 169.28 436.13 46.32 492.09 169.28 507.07 169.28 442.43 28.78"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0720e4ecc0b2fe893457a325d7d4917e.svg";
export { ForwardRef as ReactComponent };